import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchAppLevelScopesTE = <E = CF.API.ApiError>(
  { appId, userId }: { appId: string; userId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.FetchScopesResponse> =>
  fetchTE<CF.API.Users.FetchScopesResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/myscopes`,
      method: 'GET',
    },
    onRejected,
  );

export const fetchUserLevelScopesTE = <E = CF.API.ApiError>(
  { userId, sessionToken }: { userId: string; sessionToken?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.FetchScopesResponse> =>
  fetchTE<CF.API.Users.FetchScopesResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/myscopes`,
      method: 'GET',
      sessionToken,
    },
    onRejected,
  );
